import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-error"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "field-container__radio-grid" }
const _hoisted_5 = {
  class: "grid",
  "data-layout": "quarters"
}
const _hoisted_6 = { for: "amount-custom" }
const _hoisted_7 = {
  key: 2,
  class: "field-container__error-text",
  id: "amount-error"
}
const _hoisted_8 = {
  key: 3,
  class: "field-container__message",
  id: "amount-message"
}

import { computed, ref, useSlots, watch } from 'vue';
import RadioFormInput from '@src/components/shared/form_elements/RadioFormInput.vue';
import { useI18n } from 'vue-i18n';
import TextRadioFormInput from '@src/components/shared/form_elements/TextRadioFormInput.vue';
import { useAriaDescribedby } from '@src/components/shared/composables/useAriaDescribedby';

interface Props {
	modelValue: string;
	paymentAmounts: number[];
	minimumAmount?: number;
	showError?: boolean;
	label?: String;
	errorMessage?: String;
	minimumAmountMessage?: string;
	ariaDescribedby?: string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AmountField',
  props: {
    modelValue: {},
    paymentAmounts: {},
    minimumAmount: { default: 0 },
    showError: { type: Boolean, default: false },
    label: {},
    errorMessage: {},
    minimumAmountMessage: { default: '' },
    ariaDescribedby: {}
  },
  emits: [ 'update:modelValue', 'field-changed' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const slots = useSlots();

const { n } = useI18n();
const amount = ref<number>( Number( props.modelValue ) );
const ariaDescribedby = useAriaDescribedby(
	'amount',
	computed<boolean>( () => false ),
	computed<boolean>( () => props.showError ),
	computed<boolean>( () => !!slots.message ),
	computed<string | undefined>( () => props.ariaDescribedby )
);
const isCustomAmount = computed<boolean>( () => amount.value > 0 && props.paymentAmounts.indexOf( amount.value ) === -1 );

const getFormattedCustomAmount = (): string => {
	if ( !isCustomAmount.value ) {
		return '';
	}
	return n( amount.value / 100, 'decimal' );
};

const customAmount = ref<string>( getFormattedCustomAmount() );

const updateAmountFromRadio = ( newAmount: number ) => {
	customAmount.value = '';
	emit( 'update:modelValue', String( newAmount ) );
	emit( 'field-changed' );
};

const updateAmountFromCustom = ( newAmount: string ) => {
	newAmount = newAmount.trim();
	if ( newAmount === '' ) {
		amount.value = 0;
		return;
	}

	const numericalAmount = Number( newAmount.replace( /,/, '.' ) );
	if ( isNaN( numericalAmount ) ) {
		amount.value = 0;
		return;
	}

	amount.value = Math.trunc( numericalAmount * 100 );
};

const setCustomAmount = (): void => {
	customAmount.value = getFormattedCustomAmount();
	if ( amount.value > 0 ) {
		emit( 'update:modelValue', String( amount.value ) );
	} else {
		emit( 'update:modelValue', '' );
		emit( 'field-changed' );
	}
};

const resetErrorInput = (): void => {
	if ( props.showError ) {
		customAmount.value = '';
	}
};

watch( () => props.modelValue, ( newValue: string ) => {
	amount.value = Number( newValue );
	customAmount.value = getFormattedCustomAmount();
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(["field-container flow", [ `locale-${ _ctx.$i18n.locale }` ]]),
    id: "payment-form-amount",
    "data-error": __props.showError ? true : null,
    "data-max-width": ""
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("legend", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t( 'donation_form_payment_amount_help_text' )), 1),
    (__props.minimumAmountMessage!='')
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.minimumAmountMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.paymentAmounts, (paymentAmount, index) => {
          return (_openBlock(), _createBlock(RadioFormInput, {
            key: index,
            "native-value": paymentAmount,
            name: "amount",
            modelValue: amount.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
              updateAmountFromRadio
            ],
            disabled: paymentAmount < __props.minimumAmount,
            id: `amount-${paymentAmount}`,
            "aria-invalid": __props.showError,
            "aria-describedby": _unref(ariaDescribedby)
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$n( paymentAmount / 100, 'euros' )), 1)
            ]),
            _: 2
          }, 1032, ["native-value", "modelValue", "disabled", "id", "aria-invalid", "aria-describedby"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flow", { active: isCustomAmount.value }])
    }, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('donation_form_payment_amount_label')), 1),
      _createVNode(TextRadioFormInput, {
        modelValue: customAmount.value,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((customAmount).value = $event)),
          updateAmountFromCustom
        ],
        "input-type": "text",
        "input-id": "amount-custom",
        "has-message": false,
        "has-error": __props.showError,
        name: "custom-amount",
        "radio-clicked": setCustomAmount,
        "radio-checked": isCustomAmount.value,
        placeholder: _ctx.$t( 'form_for_example', { example: _ctx.$t( 'donation_form_custom_placeholder' ) } ),
        onKeydown: _withKeys(setCustomAmount, ["enter"]),
        onBlur: setCustomAmount,
        onFocus: _withModifiers(resetErrorInput, ["prevent"]),
        "aria-invalid": __props.showError,
        "aria-describedby": _unref(ariaDescribedby)
      }, null, 8, ["modelValue", "has-error", "radio-checked", "placeholder", "aria-invalid", "aria-describedby"])
    ], 2),
    (__props.showError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true),
    (!__props.showError && _ctx.$slots.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
          _renderSlot(_ctx.$slots, "message")
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})